import React from 'react';
import { Box, CircularProgress, Paper } from '@mui/material';
import { SEARCE_COLORS } from '../../theme';
import SectionTitle from './SectionTitle';

interface HighlightsLowlightsProps {
  highlights: string[];
  lowlights: string[];
  highlightsLoading?: boolean;
  lowlightsLoading?: boolean;
}

interface ListProps {
  items: string[];
  dotColor: string;
}

const listRowShellSx = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
  p: '9px 12px',
  background: '#f8fafc',
  borderRadius: '6px',
  border: '1px solid #f1f5f9',
} as const;

const ItemList: React.FC<ListProps> = ({ items, dotColor }) => (
  <Box component="ul" sx={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '8px', m: 0, p: 0 }}>
    {items.map((item, idx) => (
      <Box
        component="li"
        key={idx}
        sx={{
          ...listRowShellSx,
          fontSize: '0.8125rem',
          lineHeight: 1.5,
        }}
      >
        <Box
          sx={{
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: dotColor,
            mt: '5px',
            flexShrink: 0,
          }}
        />
        <Box>{item}</Box>
      </Box>
    ))}
  </Box>
);

const cardSx = {
  borderRadius: '10px',
  p: '18px 20px',
  background: '#fff',
  border: `1px solid ${SEARCE_COLORS.border}`,
  boxShadow: '0 1px 4px rgba(0,0,0,.06), 0 0 0 1px rgba(0,0,0,.03)',
};

const HighlightsLowlights: React.FC<HighlightsLowlightsProps> = ({
  highlights,
  lowlights,
  highlightsLoading = false,
  lowlightsLoading = false,
}) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
      gap: '18px',
      mb: '20px',
    }}
  >
    <Paper
      elevation={0}
      sx={{ ...cardSx, borderLeft: `4px solid ${SEARCE_COLORS.success}` }}
    >
      <Box sx={{ display: 'block' }}>
        <SectionTitle>Highlights</SectionTitle>
      </Box>
      {highlightsLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress size={32} sx={{ color: SEARCE_COLORS.primary }} />
        </Box>
      ) : (
        <ItemList items={highlights} dotColor={SEARCE_COLORS.success} />
      )}
    </Paper>
    <Paper
      elevation={0}
      sx={{ ...cardSx, borderLeft: `4px solid ${SEARCE_COLORS.error}` }}
    >
      <Box sx={{ display: 'block' }}>
        <SectionTitle>Lowlights</SectionTitle>
      </Box>
      {lowlightsLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress size={32} sx={{ color: SEARCE_COLORS.primary }} />
        </Box>
      ) : (
        <ItemList items={lowlights} dotColor={SEARCE_COLORS.error} />
      )}
    </Paper>
  </Box>
);

export default HighlightsLowlights;
